<template>
<transition name="router-anim" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutDown">
  <v-card >
      <v-card-title>
        {{ contentTitle}}
      <v-btn color="green white--text" v-if="IsAccessExecuteQueryDB" @click.native="()=>setState('Database')">Database Query</v-btn>
       <v-btn color="green white--text" v-if="IsAccessExecuteMetaUtil" @click.native="()=>setState('MetaUtil')">MetaUtil Command</v-btn>
       <v-btn color="green white--text" v-if="IsAccessViewAgentLogs" @click.native="()=>setState('Log')">Logs</v-btn>
       <v-btn color="green white--text" v-if="IsAccessUploadFile" @click.native="()=>setState('UploadFile')">Upload File</v-btn>
       <v-btn color="green white--text" @click.native="cancel">Cancel</v-btn>
      <v-spacer></v-spacer>
    </v-card-title>
     <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
    <v-card key="1" v-if="state=='Database'">
            <v-spacer></v-spacer>
             <v-list>
                  <template  v-for="ds in datasets">
              <v-list-tile :key="ds.TenantID" avatar ripple @click="DatasetsSelected(ds)" >
                <v-list-tile-content >
                    <v-list-tile-sub-title> {{ ds.TenantCode }} -  {{ ds.Description }} ({{ ds.TenantID }}) </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            </v-list>
            {{ TenantCode }}
             <v-flex xs12 sm12 md12>
                  <v-textarea
                    label="DatabaseQuery" v-model="DatabaseQuery"
                    box
                  ></v-textarea>
                  </v-flex>
                     <v-data-table
        :headers="Object.keys(dbResult[0]||{})"
        :items="dbResult"
        :pagination.sync="pagination"
        :search="search"
        :rows-per-page-items=[10,20,35]
        class="elevation-1"
      >
      <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header === pagination.sortBy ? 'active' : '', true]"
              @click="changeSort(header)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header}}
            </th>
          </tr>
        </template>
       <template slot="items" slot-scope="props">
          <td class="text-xs-center hidden-xs-only" v-bind:key="_header"  v-for="_header in Object.keys(dbResult[0]||{})" >{{ props.item[_header] }}</td>
       </template>
        <template slot="no-data">
          Sorry, nothing to display here.
        </template>
        Your search for "{{ search }}" found no results.

      </v-data-table>
            <pre>
              {{errorOrsuccessMessage}}
            </pre>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="executeDB">
                OK
              </v-btn>
            </v-card-actions>
      </v-card>
<v-card key="2" v-if="state=='MetaUtil'">
            <v-spacer></v-spacer>
             <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Name" v-model="MetaUtilCommand"
                    box
                  ></v-text-field>

                  </v-flex>
            <pre>
              {{errorOrsuccessMessage}}
            </pre>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="executeMetaUtil">
                OK
              </v-btn>
            </v-card-actions>
      </v-card>
      <v-card key="3" v-if="state=='Log'">
            <v-spacer></v-spacer>
             <v-list>
                  <template  v-for="lf in logFiles">
              <v-list-tile :key="lf" avatar ripple @click="LogFileSelected(lf)" >
                <v-list-tile-content >
                    <v-list-tile-sub-title> {{ lf.split('\\').pop() }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            </v-list>
            <pre>
              {{errorOrsuccessMessage}}
            </pre>
      </v-card>

      <v-card key="4" v-if="state=='UploadFile'">
            <v-spacer></v-spacer>
            <input type="file" ref="image" accept="*/*" multiple="multiple" @change="selectFilesForUpload">
       <v-btn color="green white--text" @click.native="uploadFile">Upload File</v-btn>
            <pre>
              {{errorOrsuccessMessage}}
            </pre>
            <v-btn outline color="green darken-2" @click.native="SyncAgent">Refresh<v-icon>sync</v-icon></v-btn>
            <v-btn outline color="green darken-2" @click.native="CheckOnlineStatus">Check Online Status:{{IsOnline===true?'Online':(IsOnline===false?'Offline':(IsOnline===null?'Agent Name Not Found':'Unknown'))}}<v-icon v-if="IsOnline===true" right dark>done_all</v-icon><v-icon right dark  v-if="IsOnline===false">block</v-icon><v-icon right dark  v-if="IsOnline===null">warning</v-icon> </v-btn>

             <v-list>
                  <template  v-for="lf in GetFiles()">
              <v-list-tile :key="lf.Name" avatar ripple  >
                <v-list-tile-content >
                    <v-list-tile-sub-title> {{ lf.Name }} - {{lf.LastWriteTime}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
 <v-list-tile  avatar ripple >
                <v-list-tile-content >
                    <v-list-tile-sub-title> <v-icon right >warning</v-icon> Note: If pushing file of greater than 5MB & upload fails. Wait 5 minutes, refresh few times and then attempt again.</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>             </v-list>
      </v-card>
     <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
    <v-dialog v-model="dialogSuccess" width="500">
      <v-card>
        <v-spacer></v-spacer>
        <v-card-text>
          {{errorOrsuccessMessage}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialogSuccess = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</transition>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import DataService from "@/services/data-service";
const dataService = new DataService();
import moment from "moment";
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { store } from "@/main.ts";

export default {
  name: "developerboard",
  props: [],
  data: () => ({
    search:"",
    errors:[],
    SelectedTenant:null,
    TenantCode:'',
    dialog: false,
    dialogDetails:false,
    dialogSuccess: false,
    dialogDetailsAction:null,
    loading: false,
    actioninProgress: false,
    errorOrsuccessMessage: "",
    state:null,
    MetaUtilCommand:"--help",
    DatabaseQuery:"Select * from Tenant",
    datasets:[],
    dbResult:[],
    logFiles:[],
    IsOnline:undefined,
    select:null,
    pagination: {
      sortBy: "DisplayName"
    },
    paginationFile: {
      sortBy: "Name"
    },
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Actions";
    },
    contentTitle(){
      return ""
    },
    IsAccessExecuteQueryDB() {
      return this.$store.getters.IsValidCode('AH2DB0600');
    },
    IsAccessExecuteMetaUtil() {
      return this.$store.getters.IsValidCode('AH2EM1011');
    },
    IsAccessViewAgentLogs() {
      return this.$store.getters.IsValidCode('AH2VL0404');
    },
    IsAccessUploadFile() {
      return this.$store.getters.IsValidCode('AH2UF0312');
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    $route(to, from) {
      console.log(to.params.id);
      this.initialize();
    }
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    next();
  },

  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      if(!this.IsAccessExecuteQueryDB && !this.IsAccessExecuteMetaUtil && !this.IsAccessViewAgentLogs && !this.IsAccessUploadFile) {
      this.$router.replace(`/error/You don't have any command permission for Developer View/code/`);
        return;
      }
      if(!this.$store.getters.getIsAuthenticated || !this.$route.params.agentId){
        this.Logout();
      }else{
      this.getDataFromServer();
      }
    },setState(_state){
      this.state=_state;
      this.errorOrsuccessMessage="";
    },cancel(){
      this.$router.replace("/controlboard");
    },DeveloperPanel(item){
      this.$router.replace("/developerBoard/"+item.AgentId);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },closeDetails() {
      this.dialogDetails=false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },executeMetaUtil(){
      this.loading = true;
      this.errorOrsuccessMessage="Please wait...!"
       dataService.executeMetaUtil(this.$route.params.agentId,this.MetaUtilCommand).then(result => {
          this.loading = false;
          this.errorOrsuccessMessage=result;
        });
    },executeDB(){
      this.loading = true;
      this.errorOrsuccessMessage="Please wait...!"
           this.dbResult=[];
       dataService.DatabaseQuery(this.$route.params.agentId,this.TenantCode,this.DatabaseQuery).then(result => {
         try{
            this.dbResult=JSON.parse(result);
            this.errorOrsuccessMessage='';
            if(!Array.isArray(this.dbResult))  {
              this.errorOrsuccessMessage=this.dbResult.Message;
              this.dbResult=[];
            }
         }catch(err){
          this.errorOrsuccessMessage=result;
         }
          this.loading = false;
        });
    },DatasetsSelected(ds){
      if(this.TenantCode==ds.TenantCode){
          this.TenantCode='';
      }else{
        this.TenantCode=ds.TenantCode;
      }
    },
    done() {
      this.actioninProgress = true;
      this.errors=[];
      if (!this.editedItem.Name) {
        this.errors.push('Name required.');
      }
      if (!this.editedItem.DisplayName) {
        this.errors.push('Display Name required.');
      }
      if (!this.editedItem.AutoUpdateName) {
        this.errors.push('Auto-Update Name required.');
      }
      if (!this.editedItem.Email) {
        this.errors.push('Email required.');
      }
      if (!this.editedItem.Password) {
        this.errors.push('Password required.');
      }
      if (this.errors.length)
      {
        this.actioninProgress = false;
         return;
      }
      
      if(this.editedItem.AgentId)
      {
      dataService.updateAgent(this.editedItem).then((agentId)=>{
          this.getDataFromServer().then(()=>{
          this.actioninProgress = false;
          this.close();
          });
        });
      }else{
      dataService.createAgent(this.editedItem).then((agentId)=>{
          this.getDataFromServer().then(()=>{
          this.actioninProgress = false;
          this.close();
          });
        });
      }
    },openMonitor(item){
      window.open(item.MonitorLink,'_blank').focus();
    },
    formatDate2(value){
     if (value) {
       return moment(String(value)).format("MMM Do YYYY");
      }
    },getServerName(InfoJSON){
     
      var componentserverPotValue=((((InfoJSON||{}).Agris||{}).Output||'').split('componentserver="')[1]||"").split('"')[0]||'';
     return componentserverPotValue;
    },
    formatDate(value) {
                var delta = Math.round((+new Date - value) / 1000);

          var minute = 60,
              hour = minute * 60,
              day = hour * 24,
              week = day * 7;

          var fuzzy;

          if (delta < 30) {
              fuzzy = 'just now.';
          } else if (delta < minute) {
              fuzzy = delta + ' seconds ago.';
          } else if (delta < 2 * minute) {
              fuzzy = 'a minute ago.'
          } else if (delta < hour) {
              fuzzy = Math.floor(delta / minute) + ' minutes ago.';
          } else if (Math.floor(delta / hour) == 1) {
              fuzzy = '1 hour ago.'
          } else if (delta < day) {
              fuzzy = Math.floor(delta / hour) + ' hours ago.';
          } else if (delta < day * 2) {
              fuzzy = 'yesterday';
          }else if(delta < day*31){
             fuzzy = Math.trunc(delta/day)+' days ago';
          }else if(delta < day * 62){
             fuzzy = 'a month ago';
          }else{
             fuzzy = Math.trunc(Math.trunc(delta/day)/30)+' months ago';
          }
          return fuzzy
    },
    LogFileSelected(lf){
        dataService.logFile(this.$route.params.agentId,lf).then((result)=>{
           this.errorOrsuccessMessage=result;
          });
    },
    getDataFromServer() {
      return new Promise((resolve, reject) => {
        this.loading = true;        
        dataService.getAgent(this.$route.params.agentId).then(_agent => {
          console.log(_agent);
          this.loading = false;
          this.agent = _agent;
          resolve(_agent);
          dataService.getDatasets(this.$route.params.agentId).then((datasets)=>{
           this.datasets=datasets
          });
          dataService.logFiles(this.$route.params.agentId).then((logFiles)=>{
           this.logFiles=logFiles
          });
        });
      });
    },
    selectFilesForUpload(e){
       const files = e.target.files;
       if(!files.length) 
       {
          this.imageName = '';
          this.imageFile = '';
          this.imageUrl = '';
         }
         this.UploadFiles=[];
         this.loadFiles(files,0) ;
			
    },loadFiles(files,index){
        this.imageName = files[index].name;
        if(this.imageName.lastIndexOf('.') <= 0) {
                      return
                    }else{
                      const fr = new FileReader ()
                      fr.readAsDataURL(files[index])
                      fr.addEventListener('load', () => {
                        this.imageUrl = fr.result
                        this.imageFile = files[index] // this is an image file that can be sent to server...
                        
                        this.UploadFiles.push({
                              fileName:this.imageName,
                              fileAsString:this.imageUrl
                          });
                          if(files.length>(index+1)){
                            this.loadFiles(files,index+1);
                          }
                      });
                    }
    },
    uploadFile(){
       this.actioninProgress = true;
        dataService.UploadFile(this.UploadFiles,this.$route.params.agentId).then(()=>{
            this.getDataFromServer().then(()=>{
                this.actioninProgress = false;
                });
            },()=>{
                this.actioninProgress = false;
                this.errorOrsuccessMessage="Something went wrong please try again!";
            });
    },GetFiles(){
    let agentFiles=(((this.agent||{}).InfoJSON||{}).Files||[]);
    let uploadedFiles=(this.UploadFiles||[]).map(f=>f.fileName.toLowerCase());
    let updatedFiles=agentFiles.filter(f=>uploadedFiles.map(up=>f.Name.toLowerCase()==up).filter(uf=>uf)[0]).filter(e=>e);
    console.log(updatedFiles)
    return updatedFiles;
  }
  ,CheckOnlineStatus(){
       this.actioninProgress = true;
       this.IsOnline=undefined;
     dataService.CheckOnlineStatus(this.$route.params.agentId).then((IsOnline)=>{
        this.actioninProgress = false;
        this.IsOnline=IsOnline;
     })
    },ForceRestartAgent(){
       this.actioninProgress = true;
      dataService.ForceRestartAgent(this.$route.params.agentId).then(()=>{
        this.actioninProgress = false;
      });
    },
    SyncAgent(){
       this.actioninProgress = true;
      dataService.syncAgent(this.$route.params.agentId).then(()=>{
        this.getDataFromServer();
        this.actioninProgress = false;
      });
    }
  }
};
</script>

<style scoped>
.cell-font-size {
  font-size: 12px;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}

</style>
